import type { NotificationModuleCapabilities } from '../types/notification';

/**
 * Capabilities from mounted arkhrmsapi notification.routes.js.
 *
 * Mounted (auth only):
 * - GET  /notifications
 * - GET  /notifications/:notificationId
 * - GET  /notifications/unread-count
 * - POST /notifications/:notificationId/read
 * - POST /notifications/read-all
 * - GET  /notifications/preferences
 * - PUT  /notifications/preferences/:notificationType
 */
export const NOTIFICATION_ROUTE_CAPABILITIES = {
  unreadCount: true,
  list: true,
  details: true,
  markRead: true,
  markAllRead: true,
  preferences: true,
  updatePreferences: true,
} as const;

export function getNotificationModuleCapabilities(
  _permissions: readonly string[] = [],
): NotificationModuleCapabilities {
  return {
    canViewUnreadCount: NOTIFICATION_ROUTE_CAPABILITIES.unreadCount,
    canViewList: NOTIFICATION_ROUTE_CAPABILITIES.list,
    canViewDetails: NOTIFICATION_ROUTE_CAPABILITIES.details,
    canMarkRead: NOTIFICATION_ROUTE_CAPABILITIES.markRead,
    canMarkAllRead: NOTIFICATION_ROUTE_CAPABILITIES.markAllRead,
    canViewPreferences: NOTIFICATION_ROUTE_CAPABILITIES.preferences,
    canUpdatePreferences: NOTIFICATION_ROUTE_CAPABILITIES.updatePreferences,
  };
}
